import React from 'react'
import {createSelector} from 'reselect'
import TasksApi from './Api/TasksApi'
import {receivedServerData} from "../../Common/Data/DataFetcher";

export const TASK_EVENTS_NAMESPACE = 'taskEvents';

const getTaskEventsWithId = (state, props) =>
    (state.taskEvents || {})[props.taskId];

export const getTaskEvents = createSelector(
    getTaskEventsWithId,
    (taskEvents) => {
        return taskEvents || []
    }
);

export const fetchTaskEvents = {
    fetchingApiFunc: TasksApi.fetchTaskEvents,
    selector: getTaskEvents,
    paramsFromProps: (props) => {
        return [props.taskId]
    },
    dataNamespace: TASK_EVENTS_NAMESPACE
};

export function receivedTaskEventsData(data) {
    return receivedServerData(data, TASK_EVENTS_NAMESPACE)
}



